import React, { Component, Fragment } from 'react';

import { checkUndefine } from '../../../../../../../helpers/functions';
import { UPLOAD_DIRECTORY } from '../../../../../../../constants/Define';

import {
    FormWrapperInputComponent,
} from "../../../../../common/component/Index";
import Wrapper from '../../../../../common/component/Wrapper';
import Input from '../../../../../common/component/Input';
import Ripple from '../../../../../common/component/Ripple';
import Modal from '../../../../../common/component/Modal';
import MessageValidation from "../../../../../common/MessageValidation";
import RichTextEditor, { ClassicEditor } from '../../../../../common/component/RichTextEditor';

import { TripItinerary as TripItineraryModel } from '../../../../../../../models/Tour';

import { Icon, Divider } from 'antd';

import './TripItinerary.less';

export default class TripItinerary extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    render() {
        const { t, tour, validation } = this.props;
        return (
            <Wrapper className="tour-detail-trip-itinerary row">
                {validation.tripItinerary && !tour.tripItinerary.length &&
                    <MessageValidation validation={validation.tripItinerary} className="ml-2"
                        message={validation.tripItinerary ? (typeof validation.tripItinerary === 'string' ? validation.tripItinerary : validation.tripItinerary.messageError) : t('validation.statusCode.code.1')} />
                }
                {(tour.tripItinerary || []).map((trip, index) => (
                    <Fragment key={index}>
                        <Wrapper className="col-md-12 trip-day">
                            <FormWrapperInputComponent
                                typeInput={true}
                                classLabel="col-md-2"
                                classInputForm="col-md-10"
                                labelTitle={`${t(`item.tour.day`)} ${index + 1}`}
                                className="mb-0"
                            >
                                <FormWrapperInputComponent
                                    isRequired={'right'}
                                    isValidation={true}
                                    dataValidation={trip.title}
                                    validation={validation.tripItinerary && validation.tripItinerary[index]}
                                    messageBelowInput={true}
                                    labelTitle={t(`item.tour.tourTitle`)}
                                >
                                    <Input placeholder="" type={`text`}
                                        className={`form-control`}
                                        name={`tripItineraryTitle${index}`} onChange={e => this.onChangeTripItineraryTitle(index, e.target.value)}
                                        value={checkUndefine(trip.title)} />
                                </FormWrapperInputComponent>
                                <FormWrapperInputComponent
                                    labelTitle={`${t(`item.tour.tripItineraryContent`)}`}
                                    className="mb-0"
                                >
                                    <RichTextEditor
                                        editor={ClassicEditor}
                                        data={trip.content || ""}
                                        config={{ uploadDirectory: UPLOAD_DIRECTORY.TOUR_THUMB }}
                                        onChange={(event, editor) => {
                                            const value = editor.getData();
                                            return this.onChangeTripItineraryContent(index, value);
                                        }}
                                    />
                                </FormWrapperInputComponent>
                            </FormWrapperInputComponent>
                            <Ripple className="btn btn-remove-day" onClick={() => this.onRemoveTripItinerary(index)}>
                                <Icon type="delete" className="mr-2" />
                            </Ripple>
                        </Wrapper>
                        {tour.tripItinerary && tour.tripItinerary.length && <Divider className={index === tour.tripItinerary.length - 1 ? 'last-divider' : ''} />}
                    </Fragment>
                ))}
                {(tour.tripItinerary || []).length < tour.lengthOfTour &&
                    < Ripple className="btn btn-add-day" onClick={this.onAddNewTripItinerary} style={{ border: validation.tripItinerary && !tour.tripItinerary.length ? '1px solid red' : undefined }}>
                        <Icon type="plus" className="mr-2" />{`${t('action.add')} ${t('item.tour.day').toLowerCase()}`}
                    </Ripple>
                }
            </Wrapper>
        )
    }

    onChangeTripItineraryTitle = (index, value) => {
        const tour = this.props.tour;
        const tripItinerary = (tour.tripItinerary || [])
        if (tripItinerary[index]) {
            tripItinerary[index].title = value;
        }
        this.props.onChange('tripItinerary', tripItinerary);
    }

    onChangeTripItineraryContent = (index, value) => {
        const tour = this.props.tour;
        const tripItinerary = (tour.tripItinerary || [])
        if (tripItinerary[index]) {
            tripItinerary[index].content = value;
        }
        this.props.onChange('tripItinerary', tripItinerary);
    }

    onAddNewTripItinerary = () => {
        const tour = this.props.tour;
        const tripItinerary = (tour.tripItinerary || []).concat([new TripItineraryModel()]);
        this.props.onChange('tripItinerary', tripItinerary)
    }

    onRemoveTripItinerary = (index) => {
        const { t, tour } = this.props;
        const { confirm } = Modal;
        const removeTripItinerary = () => {
            let tripItinerary = (tour.tripItinerary || []);
            if (index >= 0) tripItinerary.splice(index, 1)
            this.props.onChange('tripItinerary', tripItinerary);
        }
        confirm({
            title: t(`notification.sureRemove`),
            okText: t(`action.remove`),
            cancelText: t(`action.cancel`),
            onOk: removeTripItinerary,
        });
    }

}

TripItinerary.defaultProps = {
    onChange: (fieldName, value) => { },
}

